import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * LoadingFallback component displayed during lazy loading of page components
 * Uses semantic styling and configuration support
 */
const getLoadingMessage = (operation) => {
  const messages = {
    loadingCircles: 'Loading your circles...',
    creatingCircle: 'Creating new circle...',
    updatingCircle: 'Updating circle details...',
    deletingCircle: 'Deleting circle...',
    sendingInvitation: 'Sending invitation...',
    loadingInvitations: 'Loading invitations...',
    acceptingInvitation: 'Accepting invitation...',
    decliningInvitation: 'Declining invitation...',
    removingMember: 'Removing member...',
  };
  return messages[operation] || 'Loading...';
};

const LoadingFallback = ({ operation, className = '' }) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  return (
    <div className={`flex items-center justify-center p-4 ${className}`}>
      <div className={`animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 ${semantic.loadingSpinnerActive} ${semantic.loadingSpinnerBorder} mr-3`}></div>
      <span className={semantic.loadingText}>
        {replace(getLoadingMessage(operation))}
      </span>
    </div>
  );
};

LoadingFallback.propTypes = {
  operation: PropTypes.string,
  className: PropTypes.string
};

export default LoadingFallback;

